import { TimezonesService, ITimezone } from "../../../services/timezone.service";

class TimezonesItemController implements ng.IComponentController {
    private timezone: ITimezone;

    constructor(private TimezonesService: TimezonesService,
                private $state: ng.ui.IStateService,
                private SweetAlert: any) {
        'ngInject';
    }

    deleteTimezone() {
        this.SweetAlert.swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        }, (isConfirm) => {
            if (isConfirm) {
                this.TimezonesService.delete(this.timezone.id).then(() => {
                    this.$state.go('^', {reload: true});
                });
            } else {

            }
        });
    }
}

export const timezonesItemComponent: ng.IComponentOptions = {
    controller: TimezonesItemController,
    bindings: { 
        timezone: '<',
        hourCodes: '<'
    },
    template: require('./timezones.item.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.item.component.ts